<rd-popup-default-template
  [title]="'redeem_cash_v2.checkout.link_preferred_account' | translate"
  [dialogContent]="dialogContent"
  [showButtons]="shouldShowButtons"
  [primaryButtonAriaLabel]="
    'accessibility.redeem_cash_v2.confirm_link_account' | translate
  "
  [primaryButtonText]="buttonTextKey() | translate"
  [primaryButtonClass]="'link-an-account-submit'"
  [primaryButtonFullWidth]="true"
  (primaryButtonClick)="linkAnAccount()"
  [primaryButtonIsDisabled]="shouldShowButtonLoading">
  <ng-template #dialogContent>
    <div class="link-account-dialog-content">
      <p class="error-message" *ngIf="enrollmentsError">
        {{ enrollmentsError.message }}
      </p>
      <p class="error-message" *ngIf="createOrUpdateMembershipError">
        {{ createOrUpdateMembershipError.errors[0].message }}
      </p>

      <ng-container [ngSwitch]="componentRenderState">
        <ng-container *ngSwitchCase="'loading'">
          <div
            class="enrollment-list-item loading"
            *ngFor="let number of [0, 1, 2]">
            <div class="enrollment-product-type-loading"></div>
            <div class="enrollment-group-reference-id-loading"></div>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'empty'">
          <div class="empty-state-container">
            <rd-shared-icon
              class="empty-enrollments-icon"
              [iconSymbol]="'icon-rc-enrollments-empty'"
              [iconTheme]="'primary'"></rd-shared-icon>
            <h2 class="empty-enrollments-title">
              {{
                'redeem_cash_v2.link_account_dialog.empty_enrollments_title'
                  | translate
              }}
            </h2>
            <p class="empty-enrollments-message">
              {{
                'redeem_cash_v2.link_account_dialog.empty_enrollments_message'
                  | translate
              }}
            </p>
          </div>
        </ng-container>

        <ng-container
          *ngIf="
            componentRenderState === 'content' ||
            componentRenderState === 'submitting'
          ">
          <div class="link-account-form" [formGroup]="linkAccountFormGroup">
            <rd-rcv2-link-account-form
              formControlName="linkAccountForm"
              [enrollments]="$any(enrollments)"
              [formData]="formData"
              [shouldAllowRedeemToOtherAccount]="
                shouldAllowRedeemToOtherAccount
              "
              (enrollmentChange)="
                changeFormStatus($event)
              "></rd-rcv2-link-account-form>
            <rd-rcv2-link-account-detail-form
              *ngIf="shouldAllowRedeemToOtherAccount"
              formControlName="linkOtherBankAccountForm"
              [active]="isBankAccountFormActive"
              [formData]="formDetailData"
              [isSubmitted]="isSubmitted$"></rd-rcv2-link-account-detail-form>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </ng-template>
</rd-popup-default-template>
